import cortanaComposeStore from '../store/cortanaComposeStore';
import { mutatorAction } from 'satcheljs';

// Shift the selected item within the search menu. The selected item is determined by two numbers:
// a) the index of the section that the selected item is in
// b) the index of the selected item within its section
export default mutatorAction('shiftInlineSearchHighlight', function shiftInlineSearchHighlight(
    isIncrement: boolean
) {
    const viewState = cortanaComposeStore.viewState;
    if (!viewState.hasSelectableElement) {
        return;
    }

    let { selectedSectionIndex, resultsShown, selectedIndexInSection } = viewState;
    const sectionLengths = [...resultsShown.keys()].map(key => resultsShown.get(key).length);

    // First increment the selected index within the section
    if (isIncrement) {
        selectedIndexInSection++;
    } else {
        selectedIndexInSection--;
    }

    // Now, if the selection has left the current section (either by going off the top or the bottom) shift the selected section
    // and reset the index within the section to either the start or the end of it
    if (selectedIndexInSection >= sectionLengths[selectedSectionIndex]) {
        selectedSectionIndex = shiftSelectedSection(true, sectionLengths);
        selectedIndexInSection = 0;
    } else if (selectedIndexInSection < 0) {
        selectedSectionIndex = shiftSelectedSection(false, sectionLengths);
        selectedIndexInSection = sectionLengths[selectedSectionIndex] - 1;
    }

    viewState.selectedIndexInSection = selectedIndexInSection;
});

function shiftSelectedSection(isIncrement: boolean, sectionLengths: number[]): number {
    const viewState = cortanaComposeStore.viewState;
    let { selectedSectionIndex, resultsShown } = viewState;

    // Increment the selected section and skip over empty sections
    do {
        if (isIncrement) {
            selectedSectionIndex++;
        } else {
            selectedSectionIndex--;
        }

        if (selectedSectionIndex < 0) {
            selectedSectionIndex = [...resultsShown.keys()].length - 1;
        } else {
            selectedSectionIndex = selectedSectionIndex % [...resultsShown.keys()].length;
        }
    } while (sectionLengths[selectedSectionIndex] === 0);

    viewState.selectedSectionIndex = selectedSectionIndex;
    return selectedSectionIndex;
}
